import { render, staticRenderFns } from "./AttributeBuilder.vue?vue&type=template&id=c2b1e72a&scoped=true"
import script from "./AttributeBuilder.vue?vue&type=script&lang=js"
export * from "./AttributeBuilder.vue?vue&type=script&lang=js"
import style0 from "./AttributeBuilder.vue?vue&type=style&index=0&id=c2b1e72a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b1e72a",
  null
  
)

export default component.exports